import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import JobPost from './JobPost';
import LandingPage from './LandingPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/jobs" element={<JobPost />} />
      </Routes>
    </Router>
  );
}

export default App;